/**
 * Tarihi formatlar ve yerelleştirir
 * @param dateString ISO tarih dizesi
 * @param locale Yerel ayar (varsayılan: 'tr-TR')
 * @returns Formatlanmış tarih dizesi
 */
export const formatDate = (dateString: string, locale: string = 'tr-TR'): string => {
  try {
  const date = new Date(dateString);
    return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
    }).format(date);
  } catch (error) {
    console.error('Date formatting error:', error);
    return dateString || '-';
  }
};